import { DrawerBase } from '../../core/DrawerBase';


export class BaseGamePadBaseDrawer extends DrawerBase {
  constructor() {
    super();
    this.sourceNames = {
      spinIcon: 'game_pad_base_drawer_spin_icon',
      autoSpinIcon: 'game_pad_base_drawer_autoplay_icon',
      minusIcon: 'game_pad_base_drawer_minus_icon',
      plusIcon: 'game_pad_base_drawer_plus_icon',
      leftArrowIcon: 'game_pad_base_drawer_left_arrow_icon',
      rightArrowIcon: 'game_pad_base_drawer_rounded_right_icon',
      infinityDarkIcon: 'game_pad_base_drawer_infinity_dark_icon',
      infinityIcon: 'game_pad_base_drawer_infinity_icon',
      autoSpinStopIcon: 'assets_gamePadSrc_auto_spin_icon',
    };
  }

  getTexture({ name, scale = 1 } = {}) {
    const texture = this.createSprite(this.resources[name]);
    texture.scale.set(scale);
    texture.anchor.set(.5);
    return texture;
  }

  getSpinButton({
    scale = 1,
  } = {}) {
    const container = this.createContainer('spinButtonContainer');
    const button = this.createSprite(this.resources[this.sourceNames.spinIcon]);
    button.scale.set(scale);
    button.anchor.set(.5);
    this.setupButtonMode(container);
    this.setupButtonMode(button);
    container.addChild(
      button,
    );
    return {
      container,
      button,
      * [Symbol.iterator]() {
        yield this.container;
        yield this.button;
      },
    };
  }

  getAutoSpinButton({
    scale = 1,
    textStyle = {},
  } = {}) {
    const container = this.createContainer('autoSpinButtonContainer');
    const button = this.createSprite(this.resources[this.sourceNames.autoSpinStopIcon]);
    const countTexture = this.createText('', textStyle);
    const infinityTexture = this.createSprite(this.resources[this.sourceNames.infinityDarkIcon]);
    button.scale.set(scale);
    button.anchor.set(.5);
    infinityTexture.anchor.set(.5);
    countTexture.anchor.set(.5);
    this.setupButtonMode(container);
    this.setupButtonMode(button);
    container.addChild(
      button,
      countTexture,
      infinityTexture,
    );
    return {
      container,
      countTexture,
      infinityTexture,
      * [Symbol.iterator]() {
        yield this.container;
        yield this.countTexture;
        yield this.infinityTexture;
      },
    };
  }
}
